import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type PdfSettingsParameters = {
    name: string
    title?: string
}

const pdfSettingsDefinition: TemplateNodeDefinition<PdfSettingsParameters> = {
    nodeClass: "PdfSettings",
    validation: {
        parameters: z.object({
            name: z.string(),
            title: z.optional(z.string()),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PdfSettings extends TemplateNode<PdfSettingsParameters> {
    public override get definition() {
        return pdfSettingsDefinition
    }
}
